import { Component, ElementRef, EventEmitter, OnDestroy, OnInit, Output, ViewChild, ChangeDetectionStrategy } from "@angular/core";
import { TimelineItemService } from "../timeline-item/timeline-item.service";
import { CommonModule } from "@angular/common";
import { TranslateModule } from "@ngx-translate/core";
import { MatTooltipModule } from "@angular/material/tooltip";
import { UserActivityService } from "./user-activity.service";
import { filter, Subject, takeUntil, tap } from "rxjs";
import { ActivatedRoute } from "@angular/router";

@Component({
    selector: 'user-activity',
    templateUrl: './user-activity.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        CommonModule,
        TranslateModule,
        MatTooltipModule,
    ]
})
export class UserActivityComponent implements OnInit, OnDestroy {

    showFullActivityBox: boolean;

    activity: any;

    showActivitySpinner: boolean;

    @Output()
    onRequestCreateQuestion: EventEmitter<void> = new EventEmitter();

    @Output()
    onRequestCreateIssue: EventEmitter<void> = new EventEmitter();

    @Output()
    onRequestCreateKudos: EventEmitter<void> = new EventEmitter();

    @Output()
    onRequestScrollToTimelineItem: EventEmitter<string> = new EventEmitter();

    @ViewChild(('createKudosButton'))
    createKudosButton: ElementRef;

    private _destroy$ = new Subject<void>();

    constructor(
        private timelineItemService: TimelineItemService,
        private userActivityService: UserActivityService,
        private route: ActivatedRoute,
    ){}

    ngOnInit(): void {
        // user activity display
        const innerWidth = window.innerWidth;
        this.showFullActivityBox = innerWidth >= 992;

        this.route.params.pipe(
            filter(params => !!params['teamId']),
            tap(params => {
                const teamId = params['teamId'];
                this.showActivitySpinner = true;
                this.userActivityService.getActivityData(teamId).then((activity: any) => {
                    this.activity = activity;
                    this.showActivitySpinner = false;
                })
            }),
            takeUntil(this._destroy$)
        ).subscribe();

        this.userActivityService.shakeKudos$.pipe(
            tap(() => {
                (this.createKudosButton.nativeElement as HTMLButtonElement).classList.add('animate__animated');
                (this.createKudosButton.nativeElement as HTMLButtonElement).classList.add('animate__tada');
                (this.createKudosButton.nativeElement as HTMLButtonElement).classList.add('animate__repeat-2');
                setTimeout(() => {
                    (this.createKudosButton.nativeElement as HTMLButtonElement).classList.remove('animate__animated');
                    (this.createKudosButton.nativeElement as HTMLButtonElement).classList.remove('animate__tada');
                    (this.createKudosButton.nativeElement as HTMLButtonElement).classList.remove('animate__repeat-2');
                    (this.createKudosButton.nativeElement as HTMLButtonElement).click();
                }, 2000);
            }),
            takeUntil(this._destroy$)
        ).subscribe();
    }

    ngOnDestroy() {
        this._destroy$.next();
        this._destroy$.complete();
    }
        
    addCommentToYourMoodAction (moodId: string){
        this.timelineItemService.addCommentToYourMoodAction(moodId);
    }

    createQuestion() {
        this.onRequestCreateQuestion.emit();
    }

    createIssue() {
        this.onRequestCreateIssue.emit();
    }

    createKudos() {
        this.onRequestCreateKudos.emit();
    }

    scrollTo(target: string){
        this.onRequestScrollToTimelineItem.emit(target);
    }
}

